export const FREE_TIER_BYTES = 1073741824;

export function formatBytes(bytes) {
  if (!bytes || bytes <= 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const unitIndex = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / Math.pow(1024, unitIndex);

  return `${Math.round(value * 10) / 10} ${units[unitIndex]}`;
}

export function getQuotaPercentage(usedBytes) {
  return Math.min(Math.round((usedBytes / FREE_TIER_BYTES) * 100), 100);
}

export function isQuotaExceeded(usedBytes) {
  return usedBytes >= FREE_TIER_BYTES;
}

export function getRemainingBytes(usedBytes) {
  return Math.max(FREE_TIER_BYTES - usedBytes, 0);
}
